import React from 'react';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  id?: string;
  name: string;
  ariaText?: FieldValue;
  text: FieldValue;
  textAlign?: ButtonTextAlignment;
  icon?: () => React.JSX.Element;
  leadingIcon?: () => React.JSX.Element;
  trailingIcon?: () => React.JSX.Element;
  size?: ButtonSize;
  variant?: ButtonVariant;
  customStyles?: React.CSSProperties;
  loading?: boolean;
  responsive?: boolean;
}

/* Simplified Buttons */
export type BaseButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  dataTestid: string;
};

export enum ButtonTextAlignment {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right'
}

export enum ButtonVariant {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  ICON = 'icon',
  FRAMELESSICON = 'framelessIcon'
}

export enum ButtonSize {
  LARGE = 'large',
  SMALL = 'small'
}
